export default __webpack_public_path__ + "static/media/IMG_9373.f9235016.JPG";